import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  nameArea: {
    display: 'flex',
    alignItems: 'center'
  },

  avatarHolder: {
    marginTop: '12px',
    marginRight: '10px'
  },

  avatar: {
    width: '22px',
    height: '22px',
    fontSize: theme.size.sm,

    '& svg': {
      width: '22px',
      height: '22px'
    }
  },

  channels: {
    marginTop: '0.25rem',
    marginLeft: '32px',
    fontSize: theme.size.sm,
    color: theme.palette.textLightFaded,
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    wordBreak: 'break-all'
  }
}))

export default useStyles
